import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { getConclusioniControl } from '../validators/helpers/conclusioni-form.helper';
import { withChangeDebounced } from '@shared/operators/with-change-debounced.operator';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { cloneDeep } from 'lodash-es';
import { calcolaDataScadenzaAccertamento, calcolaDataScadenzaDiffida } from './helpers/conclusioni-listeners.helper';

export const setConclusioniProposteListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_CkProvvedimendoDi(form, store);
    my_CkProposte(form, store);
};

const my_CkProvvedimendoDi = (form: FormGroup, store: Store<Revisione53State>): void => {
    const control = getConclusioniControl(form, 'my_CkProvvedimendoDi');
    control.valueChanges.pipe(withChangeDebounced(control)).subscribe((my_CkProvvedimendoDi) => {
        if (my_CkProvvedimendoDi != '3') {
            getConclusioniControl(form, 'my_CkNominaLiq').patchValue('', { emitEvent: false });
            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                myVerbaleClone.my_SezioneI__Rilevazione.my_Conclusioni.my_CkNominaLiq = '';
                return myVerbaleClone;
            });
        }
    });
};

const my_CkProposte = (form: FormGroup, store: Store<Revisione53State>): void => {
    const control = getConclusioniControl(form, 'my_CkProposte');
    control.valueChanges.pipe(withChangeDebounced(control)).subscribe((my_CkProposte) => {
        if (my_CkProposte != '3') {
            getConclusioniControl(form, 'my_ggDiffida').patchValue('', { emitEvent: false });
        }

        if (my_CkProposte != '2') {
            getConclusioniControl(form, 'my_CkProvvedimendoDi').patchValue('', { emitEvent: false });
            getConclusioniControl(form, 'my_CkNominaLiq').patchValue('', { emitEvent: false });
        }

        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            const conclusioni = myVerbaleClone.my_SezioneI__Rilevazione.my_Conclusioni;
            if (my_CkProposte != '3') {
                conclusioni.my_ggDiffida = '';
            }
            if (my_CkProposte != '2') {
                conclusioni.my_CkProvvedimendoDi = '';
                conclusioni.my_CkNominaLiq = '';
            }
            return myVerbaleClone;
        });
        calcolaDataScadenzaDiffida(form, store);
        calcolaDataScadenzaAccertamento(form, store);
    });
};
